import { render, staticRenderFns } from "./menuWidgetActions.vue?vue&type=template&id=2d2bbf26"
import script from "./menuWidgetActions.vue?vue&type=script&lang=js"
export * from "./menuWidgetActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports